import React, { useEffect, useState } from "react";

/**
 * Thin scroll progress bar at the very top of the viewport. Gold-to-cyan
 * gradient that fills from left to right as the user scrolls.
 */
export default function ScrollProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let ticking = false;
    const handle = () => {
      const doc = document.documentElement;
      const scrolled = doc.scrollTop || document.body.scrollTop;
      const max = (doc.scrollHeight - doc.clientHeight) || 1;
      setPct(Math.min(100, Math.max(0, (scrolled / max) * 100)));
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(handle);
        ticking = true;
      }
    };
    handle();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", handle);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", handle);
    };
  }, []);

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 2,
        background: "rgba(255,255,255,0.04)",
        zIndex: 100,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          height: "100%",
          width: `${pct}%`,
          background: "linear-gradient(90deg, #D4AF37 0%, #F3CE5E 35%, #00F0FF 100%)",
          boxShadow: "0 0 12px rgba(212,175,55,0.45)",
          transition: "width 100ms linear",
        }}
      />
    </div>
  );
}
